var wheels = (function () {
    "use strict";
    ///
    /// Constants
    ///
    var wheelActivatedEventName = 'wheel-activated';
    var wheelSelectButtonDataAttribute = 'wheel-select';
    var wheelClearButtonDataAttribute = 'wheel-clear';
    var emptyWheelSelection = Object.freeze({
        WheelPartNumber: undefined,
        WheelFitment: null
    });

    /**
     * @typedef {object} wheelSelectionData
     * @prop {string} WheelFitment    The ID of the selected wheel fitment
     * @prop {string} WheelPartNumber The ID of the selected wheel part number
     */

    ///
    /// First run functions
    ///
    initialize();

    ///
    /// External interface 
    ///
    return {
        activate: activateWheel,
        clear: clearWheelSelection
    };
    
    /**
     * Triggers the activation event for a selected wheel
     * @param {wheelSelectionData} wheelSelection The selected wheel to trigger the activation event for
     * @param {(wheelSelection:wheelSelectionData)=>void} callback A function to call after the event is triggered
     */
    function triggerActivationEvent(wheelSelection, callback) {

        var wheelDescription = null;

        var batch = ridestyler.ajax.batch();
        batch.done(function(r) {
            var event = $.Event(wheelActivatedEventName);

            $.extend(event, wheelSelection, { 
                WheelDescription: wheelDescription
            });
    
            $(document.body).trigger(event, [wheelSelection, wheelDescription]);
    
            if (typeof callback === 'function')
                callback(wheelSelection);
        });
            

        if (wheelSelection.WheelFitment)
        {
            var cachedWheel = null;
            try {
                cachedWheel = JSON.parse(localStorage.getItem('cached-wheel'));
            } catch (ex) { }

            if (!cachedWheel || cachedWheel.WheelFitmentID != wheelSelection.WheelFitment)
            {
                batch.send('config-result', {
                    action: 'Wheel/GetFitmentDescriptions',
                    data: {
                        WheelFitment: wheelSelection.WheelFitment
                    },
                    callback: function(r) {
                        if (r.Success && r.Fitments.length > 0) {
                            localStorage.setItem('cached-wheel', JSON.stringify(wheelDescription = r.Fitments[0]));
                        }
                    }
                });
            }
            else {
                wheelDescription = cachedWheel;
            }
        }

        batch.execute();
    }

    /**
     * Activates a wheel as the selected wheel
     * @param {wheelSelectionData} wheelSelection The selected wheel to activate
     * @param {(wheelSelection:wheelSelectionData)=>void} callback A function to call when the activation set and optionally persisted
     * @param {boolean} [persist=true] Whether or not we want to persist the selection on the server-side
     */
    function activateWheel (wheelSelection, callback, persist) {
        if (typeof persist === 'undefined' || persist) {
            // If we're persisting the activation, send it off to the server before broadcasting the activation event
            $.getJSON("/BrowsingSession/Wheel/New", {
                partNumber: wheelSelection.WheelPartNumber,
                wheelFitment: wheelSelection.WheelFitment
            }, function (response) {
                if (!wheelSelection.WheelFitment)
                    wheelSelection.WheelFitment = response.WheelFitment;

                activateWheel(wheelSelection, callback, false);
            });

            return;
        }

        triggerActivationEvent(wheelSelection, callback);
    }

    /**
     * Clear the selected wheel
     * @param {(wheelSelection:wheelSelectionData)=>void} callback A function to call after the selection has been cleared and the activated event has been triggered
     * @param {boolean} [persist=true] Whether or not to persist the clear server-side
     */
    function clearWheelSelection(callback, persist) {
        if (typeof persist === 'undefined' || persist) {
            // If we're persisting the activation, send it off to the server before broadcasting the activation event
            $.getJSON("/BrowsingSession/Wheel/Clear", function () {
                triggerActivationEvent(emptyWheelSelection, callback);
            });

            return;
        }
        
        triggerActivationEvent(emptyWheelSelection, callback);
    }

    /**
     * Handles a successful clear/activation from the data selection attribute element event handlers
     * @param {HTMLElement} target The target of the click event
     */
    function handleSelectionEventCallback(target) {
        if (target.href) location.href = target.href;
        else if (typeof $(target).data('refresh') !== 'undefined') location.reload(true);
    }

    function setupWheelInfoPanel(panelElement) {
        $(document.body).on('wheel-activated', function (e) {
            if (!e.WheelDescription) {
                panelElement.style.display = 'none';
                return;
            }

            var wheelDescription = e.WheelDescription;
            var wheelName = wheelDescription.WheelBrandName + ' ' + wheelDescription.WheelModelName;
            var diameterMin = wheelDescription.DiameterMin;
            var diameterMax = wheelDescription.DiameterMax;
            var widthMin = wheelDescription.WidthMin;
            var widthMax = wheelDescription.WidthMax;

            var valueString;

            if (diameterMin == diameterMax && widthMin == widthMax) {
                valueString = diameterMin + 'x' + widthMin;
            } else {
                valueString = diameterMin + 'x' + widthMin + ' to ' + diameterMax + 'x' + widthMax;
            }

            $(panelElement)
                .find('h6')
                .empty()
                .append(
                    wheelName + " ",
                    $("<small/>", {
                        text: " - " + valueString
                    })
                );
        });
    } 
    
    function initialize() {
        $('.wheel-info-panel').each(function() {
            setupWheelInfoPanel(this);
        });

        $(document.body)
            .on('click', '[data-' + wheelSelectButtonDataAttribute + ']', function(e) {
                // If this is a link we don't want the user redirected until we say so
                e.preventDefault();
                
                var wheelSelection = {
                    WheelPartNumber: $(this).data('wheel-part-number'),
                    WheelFitment: $(this).data('wheel-fitment')
                };

                if (!wheelSelection.WheelPartNumber) throw "Cannot select a wheel without a part number";

                activateWheel(wheelSelection, function () {
                    handleSelectionEventCallback(e.target);
                });
            })
            .on('click', '[data-' + wheelClearButtonDataAttribute + ']', function (e) {
                // If this is a link we don't want the user redirected until we say so
                e.preventDefault();

                clearWheelSelection(function () {
                    handleSelectionEventCallback(e.target);
                });
            });
    }
})();